import http from "../httpService";
import {getBaseUrl} from "../../config";

export const submitVoip = data => {

  return http.post(
    `${getBaseUrl()}/call`,
    data
  );
};

export const submitServiceVoip = data => {
  return http.post(
    `${getBaseUrl()}/call_service`,
    data
  );
};
